// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.separator[data-v-3cc3f426] {
	display: inline-block;
	width: 1px;
	height: 20px;
	vertical-align: middle;
	margin: 0 5px 0 0;
	background: #ccc;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
